import { SITE } from "@/constants/testIds";

const STYLES = {
  Buy: "text-market-buy border-market-buy/40 bg-market-buy/10",
  Hold: "text-market-hold border-market-hold/40 bg-market-hold/10",
  Sell: "text-market-sell border-market-sell/40 bg-market-sell/10",
};

export function RecommendationBadge({ recommendation, size = "md" }) {
  if (!recommendation) return null;
  const sizeClasses = size === "lg" ? "text-sm px-3.5 py-1.5" : "text-[11px] px-2 py-0.5";
  return (
    <span
      data-testid={SITE.reportRecommendation}
      className={`inline-flex items-center rounded border font-mono font-semibold uppercase tracking-wider ${STYLES[recommendation] || STYLES.Hold} ${sizeClasses}`}
    >
      {recommendation}
    </span>
  );
}
